// JavaScript Document
jQuery(document).ready(function (jQuery) {
	jQuery('header .toggle').click(function () {
		jQuery('header').toggleClass('active');
		jQuery('body').toggleClass('open-menu');
		jQuery(".mobile-nav").toggleClass('open');
	});

	if (jQuery(".slider").length > 0) {
		function heroCarousel() {
			var swiper = new Swiper(".slider", {
				speed: 1500,
				loop: true,
				autoplay: false,
				behavior: 'smooth',
				slidesPerView: 1,
				spaceBetween: 0,
				scrollbar: {
					el: ".swiper-scrollbar",
					draggable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
		heroCarousel();
	}
  	if (jQuery(".media-slider").length > 0) {
		function mediaCarousel() {
			var swiper = new Swiper(".media-slider", {
				speed: 1500,
				loop: false,
				autoplay: false,
				behavior: 'smooth',
				slidesPerView: 1,
				spaceBetween: 0,
				scrollbar: {
					el: ".swiper-scrollbar",
					draggable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
		mediaCarousel();
	}
	if (jQuery(".product-slider").length > 0) {
		function heroCarousel() {
			var swiper = new Swiper(".product-slider", {
				speed: 1500,
				loop: true,
				autoplay: true,
				behavior: 'smooth',
				slidesPerView: 4,
				spaceBetween: 17,
				scrollbar: {
					el: ".swiper-scrollbar",
					draggable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
                  breakpoints: {
              1024: {
                  slidesPerView:4,
                  spaceBetween: 17,
              },
              767: {
                  slidesPerView: 3,
                  spaceBetween: 16,
              },
            320: {
                  slidesPerView: 2,
                  centeredSlides: false,
                  spaceBetween: 16,
              }
          }
			});
		}
		heroCarousel();
	}
	if (jQuery(".arrivals-slider").length > 0) {
		function heroCarousel() {
			var swiper = new Swiper(".arrivals-slider", {
				speed: 1500,
				loop: true,
				autoplay: false,
				behavior: 'smooth',
				slidesPerView: 2,
				spaceBetween: 18,
				scrollbar: {
					el: ".swiper-scrollbar",
					draggable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
                breakpoints: {
              1024: {
                  slidesPerView:2,
                  spaceBetween: 18,
              },
              767: {
                  slidesPerView: 2,
                  spaceBetween: 16,
              },
            320: {
                  slidesPerView: 1.5,
                  centeredSlides: false,
                  spaceBetween: 10,
              }
          }
			});
		}
		heroCarousel();
	}
    /*accordion js */
    jQuery.noConflict();
    jQuery('.panel').hide();
    jQuery(document).on('click', '.accordion, .sustain-accordion', function() {
        jQuery('.accordion').not(this).removeClass('opens');
        jQuery(this).toggleClass('opens');
        jQuery(this).next('.panel').slideToggle("fast");
        jQuery('.panel').not(jQuery(this).next('.panel')).slideUp("fast");
    });
    jQuery('.panel1').hide();
    jQuery(document).on('click', '.accordion-inner', function() {
        jQuery('.accordion').not(this).removeClass('opens'); 
        jQuery(this).toggleClass('opens');
        jQuery(this).next('.panel1').slideToggle();
        jQuery('.panel1').not(jQuery(this).next('.panel1')).slideUp();
    });
    jQuery(document).on('click', '.close-acc', function () {		
		jQuery('.sustain-accordion').removeClass('opens');
		jQuery('.panel').slideUp(300);
	});
});

'use strict';
const breakpoint = window.matchMedia('(min-width:991px)');
let mySwiper;
const breakpointChecker = function () {
	if (breakpoint.matches === true) {
		if (mySwiper !== undefined) mySwiper.destroy(true, true);
		return;
	} else if (breakpoint.matches === false) {
		return enableSwiper();
	}
};
const enableSwiper = function () {
	mySwiper = new Swiper(".review-slider", {
		speed: 1000,
		loop: true,
		behavior: 'smooth',
		slidesPerView: 1,
		spaceBetween: 0,
	});
};
breakpoint.addListener(breakpointChecker);
breakpointChecker();

jQuery(window).on("load", function () {
  if (jQuery("#carousel").length > 0) {
	jQuery('#carousel').flexslider({
		animation: "slide",		
		animationLoop: true,
        controlNav: false,
		slideshow: true,
		itemWidth: 210,
		itemMargin: 39,
		asNavFor: '#slider'
	});
  }
  if (jQuery("#slider").length > 0) {
	jQuery('#slider').flexslider({
		animation: "slide",				
		slideshow: true,
        controlNav: true,
		slideshowSpeed: 5000,
		animationLoop: true, 
		sync: "#carousel",
		start: function (slider) {
			jQuery('body').removeClass('loading');
		}
	});
  }
});

jQuery(document).ready(function() {
  // Get the maximum height among .text divs
  var maxHeight = 0;
  jQuery('.home-review .text').each(function() {
    var textHeight = jQuery(this).outerHeight();
    maxHeight = Math.max(maxHeight, textHeight);
  });

  // Set the same height for .image divs
  jQuery('.home-review .image').css('height', maxHeight);
  jQuery('.home-review .text').css('height', maxHeight);


if (jQuery(".key-ingredients .ingredient ul li").length > 0) {
  jQuery('.key-ingredients .ingredient ul li').click(function() {
    jQuery('.key-ingredients ul li').removeClass('active');
    jQuery('.key-ingredients .content ul li').removeClass('active');
    jQuery(this).addClass('active');
	  jQuery('.key-ingredients .images ul li').eq(jQuery(this).index()).addClass('active');
    jQuery('.key-ingredients .content ul li').eq(jQuery(this).index()).addClass('active');
  });
}
if (jQuery(".view-ingredients").length > 0) {	
  jQuery('.view-ingredients').click(function() {
    var popupId = jQuery(this).data('popup-id');
    jQuery('#' + popupId).css('right', '0');
  });
  jQuery('.close-popup').click(function() {
      var popupId = jQuery(this).closest('.popup').attr('id');
      jQuery('#' + popupId).css('right', '-100%');
    });
}
});

const video = document.getElementById("video");
const circlePlayButton = document.getElementById("circle-play-b");

function togglePlay() {
	if (video.paused || video.ended) {
		video.play();
	} else {
		video.pause();
	}
}
if (circlePlayButton) {
    circlePlayButton.addEventListener("click", togglePlay);
}
if (video) {
  video.addEventListener("playing", function () {
  	circlePlayButton.style.opacity = 0;
  });
  video.addEventListener("pause", function () {
  	circlePlayButton.style.opacity = 1;
  });
}

const video1 = document.getElementById("video1");
const circlePlayButton1 = document.getElementById("circle-play-b1");

function togglePlay1() {
	if (video1.paused || video1.ended) {
		video1.play();
	} else {
		video1.pause();
	}
}

if (circlePlayButton1) {
    circlePlayButton1.addEventListener("click", togglePlay1);
}
if (video1) {
  video1.addEventListener("playing", function () {
  	circlePlayButton1.style.opacity = 0;
  });
  video1.addEventListener("pause", function () {
  	circlePlayButton1.style.opacity = 1;
  });	
}

jQuery(document).ajaxComplete(function() {
  jQuery(".stamped-summary-actions-newreview").html('Leave a review');
  var reviewActions = jQuery('.stamped-summary-actions');
  if (reviewActions.length > 0 && jQuery('.stamped-pagination.stamped-reviews-ul li.new-review-pos:not(:empty)').length === 0) {
    var clonedReviewActions = reviewActions.clone();
    var newListItem = jQuery('<li class="new-review-pos"></li>').append(clonedReviewActions);
    jQuery('.stamped-pagination.stamped-reviews-ul').append(newListItem);
  }
  var reviewForms = jQuery('.new-review-form');
  if (reviewForms.length > 0) {
    var newFormDiv = jQuery('<div class="review-form"></div>').append(reviewForms);
    jQuery('.stamped-content').append(newFormDiv);
  }
  var stampedMessages = jQuery('.stamped-messages');
  if (stampedMessages.length > 0) {
    var newMessageDiv = jQuery('<div class="stamped_messages"></div>').append(stampedMessages);
    jQuery('.stamped-content').append(newMessageDiv);
  }
  jQuery('.review-form,.new-review-pos,.stamped_messages').each(function() {
    if (jQuery(this).is(':empty')) {
      jQuery(this).remove();
    }
  });
  jQuery('.stamped-summary-actions-newreview').on('click', function() {
      jQuery('#stamped-main-widget').removeAttr('id');     
      if(jQuery('form.new-review-form').hasClass('stamped-visible')){        
        jQuery(this).text('Close review');
      } else {
        jQuery(this).text('Leave a review');
      } 
    setTimeout(function() {
       jQuery('.review .shopify-app-block').children('div').attr('id', 'stamped-main-widget');
    }, 2000); 
  });
  jQuery('.stamped-form-contact-name input').on('input', function() {
    const firstName = jQuery(this).val().trim();
    if (firstName !== '') {
      jQuery('.review .shopify-app-block').children('div').attr('id', 'stamped-main-widget');
    }
  });
});